import {
    GET_BEST_TIMES_REPORT_SUCCESS,
    GET_BEST_TIMES_REPORT_LOADING
} from '../actions/BestTimesReportAction';

const initialState = {
    amazon: {
        bestTimesReportData: null,
        isLoading: true,
    },
    shopify: {
        bestTimesReportData: null,
        isLoading: true,
    },
    wholesale: {
        bestTimesReportData: null,
        isLoading: true,
    }
};

const bestReportsReportReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case GET_BEST_TIMES_REPORT_SUCCESS:
            return {
                ...state, [action?.vendor]: { bestTimesReportData: action.data, isLoading: false }
            };

        case GET_BEST_TIMES_REPORT_LOADING:
            return { ...state, [action?.vendor]: { ...state?.[action?.vendor], isLoading: action.isLoading } };

        default:
            return state;
    }
};

export default bestReportsReportReducer;
